import { BASE_URL } from 'constants/api';
import actions from './index';

export const ACTIONS = {
  GET: 'TEACHER_SLOT_DATA_GET',
  GET_SUCCESS: 'TEACHER_SLOT_DATA_GET_SUCCESS',
  GET_FAILURE: 'TEACHER_SLOT_DATA_GET_FAILURE',
};

export const get = actions.get(
  teacherSlotId => `${BASE_URL}/classroom/teacher-slots/${teacherSlotId}`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);
